// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wozkrxpdanaxzfypcnko.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvemtyeHBkYW5heHpmeXBjbmtvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg2MDIzODYsImV4cCI6MjA1NDE3ODM4Nn0.gu8oEV7m9of5aTWpUj7ov121eJGcNqoyIFgz6voBy7c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);